// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";
import type { IntegrationsVoucherGroupIdAppGroupIdVoucherGroupReferencesResult } from "@dashboardApi/apis/integrationsVoucherGroupIdAppGroupIdVoucherGroupReferences/types";
export const isIntegrationsVoucherGroupIdAppGroupIdVoucherGroupReferencesResult =
  objectOf<IntegrationsVoucherGroupIdAppGroupIdVoucherGroupReferencesResult>({
    campaigns: arrayOf(
      objectOf({
        id: string,
        name: string,
      })
    ),
    canvases: arrayOf(
      objectOf({
        id: string,
        name: string,
        step_names: arrayOf(string),
      })
    ),
    content_blocks: arrayOf(
      objectOf({
        id: string,
        name: string,
      })
    ),
  });
